export default "__VITE_ASSET__DEzCUydO__"